import React from 'react';

const ColumnsContext = React.createContext<{ usedInColumns: boolean; columns: string }>({
  usedInColumns: false,
  columns: '',
});

export default ColumnsContext;
